"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.source = void 0;
const adminDash = build({
    header: {
        title: "div",
        umbrellaMenu: {
            menuButton: "button",
            numberHours: "div",
            prepaid: "div",
            postpaid: "div",
            unlimited: "div",
            umbrellaById: "button",
        },
        userMenu: {
            menuButton: "button",
            userName: "div",
            userInitials: "div",
            settings: "button",
            privacy: "button",
            terms: "button",
            signOut: "button",
        },
    },
    sideNav: {
        logo: "button",
        minimize: "button",
        dashboard: "button",
        sessions: "button",
        students: "button",
        writingLabs: "button",
        resources: "button",
        contactUs: "button",
        settings: "button",
    },
    dashboard: {
        quickFacts: {
            studentsEnrolled: "div",
            studentsActive: "div",
            sessionHours: "div",
            writingLabHours: "div",
            sessionCount: "div",
            writingLabCount: "div",
            totalHours: "div",
            schoolYear: "div",
        },
        generalUsage: {
            activeStudentsCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            totalHoursCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            avgTutorRatingCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            totalHoursChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
            totalSessionsChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
            activeStudentsChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
            powerUsersSessionsChart: {
                range: "div",
                studentById: "div",
                error: "div",
            },
            powerUsersHoursChart: {
                range: "div",
                studentById: "div",
                error: "div",
            },
        },
        tutoring: {
            avgLessonLengthCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            avgWaitTimeCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            avgTutorRatingCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            subjectStats: {
                range: "div",
                viewAllSessions: "button",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
                gradeSelect: {
                    menuButton: "button",
                    gradeById: "button",
                },
                subjectById: {
                    gradeById: "button",
                    uniqueStudents: "div",
                    level1: "div",
                    level1Button: "button",
                    level2: "div",
                    level2Button: "button",
                    subject: "div",
                    sessions: "button",
                    minutes: "div",
                    percentOfTotal: "div",
                },
            },
            hoursChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
            completedChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
        },
        writingLabs: {
            papersReviewedCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            avgPaperLengthCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            avgTutorRatingCard: {
                range: "div",
                value: "div",
                noData: "div",
                error: "div",
            },
            hoursChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
            completedChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
            lessonsVsWLChart: {
                range: "div",
                noData: "div",
                resetFilters: "button",
                resources: "button",
                error: "div",
            },
        },
    },
    queryFilters: {
        datePicker: {
            menuButton: "button",
            dateRange: "div",
            presetFilterById: "button",
            applyDates: "button",
            previousMonth: "button",
            nextMonth: "button",
            yearSelect: "button",
            yearById: "button",
            monthById: "button",
            dateById: "button",
        },
        subjects: {
            menubutton: "button",
            allSubjects: "button",
            selectCategoryById: "button",
            selectSubjectById: "button",
            categoryChildrenById: "button",
            goBack: "button",
        },
        frequency: {
            menubutton: "button",
            optionById: "button",
        },
        pending: {
            menuButton: "button",
            optionById: "button",
        },
        clever: {
            menubutton: "button",
            comboboxInput: "input",
            optionById: "button",
        },
        search: {
            open: "button",
            close: "button",
            search: "button",
            searchInput: "input",
        },
        minutes: {
            menubutton: "button",
            minutesInput: "button",
            cancel: "button",
            apply: "button",
        },
        filterChipById: "button",
        clearFilters: "button",
    },
    tableControls: {
        export: "button",
        prev: "button",
        next: "button",
        pageInput: "input",
        totalPages: "div",
        perPage: {
            25: "button",
            50: "button",
            100: "button",
        },
    },
    lessons: {
        sortById: "button",
        lessonById: {
            notModerated: "div",
            id: "button",
            student: "button",
            studentRating: "div",
            tutor: "div",
            tutorRating: "div",
            courseId: "div",
            suject: "div",
            date: "div",
            waitTime: "div",
            duration: "div",
        },
        noUsage: {
            message: "div",
            resetFilters: "button",
            resources: "button",
        },
    },
    writingLabs: {
        sortById: "button",
        writingLabById: {
            id: "button",
            seeDetails: "button",
            tutorFeedback: "button",
            student: "button",
            tutor: "div",
            tutorRating: "div",
            courseId: "div",
            title: "div",
            charCount: "div",
            date: "div",
            turnaroundTime: "div",
            timeUsed: "div",
        },
        noUsage: {
            message: "div",
            resetFilters: "button",
            resources: "button",
        },
    },
    lesson: {
        student: "div",
        tutor: "div",
        subject: "div",
        date: "div",
        duration: "div",
        studentEmail: "div",
        screenshot: "div",
        transcript: "div",
    },
    students: {
        sortById: "button",
        studentById: {
            id: "div",
            student: "button",
            dateEnrolled: "div",
            lifetimeMinutes: "div",
            totalSessions: "div",
            tutorRating: "div",
            subjectsTaken: "button",
            minutesThisPeriod: "div",
            lessonsThisPeriod: "div",
            minutesLeft: "div",
            addMinutes: "button",
        },
        addMinutes: {
            name: "div",
            minutesById: "button",
            cancel: "button",
            submit: "button",
        },
        noUsage: {
            message: "div",
            resetFilters: "button",
            resources: "button",
        },
    },
    settings: {
        access: "div",
        startTutorial: "button",
        name: "div",
        email: "div",
        weekStart: "div",
        schoolYear: "div",
        editProfile: "button",
        addUser: "button",
        userById: {
            name: "div",
            email: "div",
            lastSignin: "div",
            access: "div",
            change: {
                menu: "button",
                edit: "button",
                remove: "button",
                permisionById: "input",
                savePermissions: "button",
            },
        },
    },
    addUserModal: {
        modal: "div",
        close: "button",
        firstName: "input",
        lastName: "input",
        email: "input",
        sendInvite: "button",
    },
    removeUserModal: {
        modal: "div",
        close: "button",
        cancel: "button",
        remove: "button",
        user: "div",
    },
    editProfileModal: {
        modal: "div",
        close: "button",
        firstName: "input",
        lastName: "input",
        currentPassword: "input",
        updatePassword: "button",
        newPassword: "input",
        confirmPassword: "input",
        month: {
            menubutton: "button",
            optionById: "button",
        },
        day: "input",
        save: "button",
        goBack: "button",
        updateStartDate: "button",
    },
    studentModal: {
        modal: "div",
        close: "button",
        name: "div",
        email: "div",
        summary: "button",
        bonusMinutes: "button",
        subjectsTaken: "button",
        totalMinutes: "div",
        totalSessions: "div",
        sessions: "button",
        totalPapers: "div",
        papers: "button",
        ratingsGiven: "div",
        ratingsReceived: "div",
        noSessions: "div",
        subjectsById: {
            subject: "div",
            minutes: "div",
        },
        noBonusHistory: "div",
        bonusMinutesById: {
            date: "div",
            minutes: "div",
        },
    },
    wlTutorFeedbackModal: {
        modal: "div",
        close: "button",
        title: "div",
        student: "div",
        feedback: "div",
        download: "button",
    },
    wlDetailsModal: {
        modal: "div",
        close: "button",
        title: "div",
        student: "div",
        notes: "div",
        characters: "div",
        format: "div",
        quotedTime: "div",
        download: "button",
    },
});
const chat = build({
    loading: "div",
    dropTarget: "div",
    header: {
        close: "button",
        toggleOpen: "button",
        startLesson: "button",
        favorite: "button",
        paymentStatus: "div",
        scheduleLesson: "button",
        gearMenu: "button",
        reportMenu: "button",
        reportUser: "button",
        contactById: {
            name: "button",
            online: "div",
            time: "div",
            previousContact: "div",
            tutorLink: "button",
        },
        export: "button",
    },
    input: {
        inputArea: "input",
        attachFile: "input",
        latex: "button",
        macros: "button",
        macrosPopup: "div",
        macroById: {
            macro: "button",
            message: "button",
        },
    },
    messages: {
        loading: "div",
        loadingPrevious: "div",
        opponentIsTyping: "div",
        opponentIsTypingAvatar: "div",
        groupById: {
            time: "div",
            seen: "div",
            avatar: "div",
            block: "div",
            textMsgById: "div",
            latexMsgById: "div",
            uploadingById: {
                image: "div",
                loading: "div",
                filename: "div",
                error: "button",
            },
            fileMsgById: {
                file: "button",
                name: "div",
                imgLoading: "div",
            },
            messageMenuById: {
                button: "button",
                editFileDetails: "button",
            },
        },
    },
});
const tutorInfo = build({
    avatar: "div",
    shortName: "div",
    tagline: "div",
    name: "div",
    about: "div",
    teachingExperience: "div",
    experienceDescription: "div",
    categoryById: "div",
    subjects: "div",
    subjectById: "div",
    categoryWithLinkById: "button",
    subjectWithLinkById: "button",
    workExperience: "div",
    workById: {
        company: "div",
        title: "div",
        years: "div",
        description: "div",
    },
    educationExperience: "div",
    educationById: {
        college: "div",
        degree: "div",
        major: "div",
        years: "div",
        description: "div",
    },
});
const selectDropdown = build({
    selectBase: "button",
    itemById: "button",
    selected: "div",
});
const whiteboard = build({
    boardById: "button",
    addBoard: "button",
    undo: "button",
    redo: "button",
    remove: "button",
    erase: "button",
    select: "button",
    move: "button",
    line: "button",
    rectangle: "button",
    circle: "button",
    freehand: "button",
    textbox: "button",
    math: "button",
    graph: "button",
    stroke: selectDropdown,
    strokeColor: selectDropdown,
    fillColor: selectDropdown,
    font: selectDropdown,
    fontColor: selectDropdown,
    fontSize: selectDropdown,
    shorcuts: "button",
    grid: selectDropdown,
    export: {
        export: "button",
        all: "button",
        current: "button",
    },
    import: "button",
    contextMenu: {
        sendToBack: "button",
        sendBackward: "button",
        sendForward: "button",
        sendToFront: "button",
    },
    items: {
        circleById: "div",
        rectangleById: "div",
        lineById: "div",
        drawById: "div",
        mathById: "div",
        imageById: "div",
        desmosById: "div",
        textById: {
            box: "div",
            input: "input",
        },
        drawFrameById: "div",
        wordSearchById: "div",
    },
    dropTarget: "div",
    uploadIndicator: "div",
    uploadFileNameById: "div",
});
const video = build({
    unsupportedBrowser: "div",
    openGoogle: "button",
    loading: "div",
    studentVideo: "div",
    tutorVideo: "div",
    video: "div",
    toggleAudio: "button",
    toggleVideo: "button",
    toggleFullscreen: "button",
    flipCamera: "button",
});
const googleDocs = build({
    docs: {
        launch: "button",
        loading: "div",
    },
    sheets: {
        launch: "button",
        loading: "div",
    },
    slides: {
        launch: "button",
        loading: "div",
    },
});
const documents = build({
    dropTarget: "div",
    upload: "button",
    uploadInput: "input",
    studentFilesById: {
        file: "div",
        name: "button",
        size: "div",
        uploading: "div",
        download: "button",
        downloadIndicator: "div",
        fileError: "div",
        remove: "button",
        removeIndicator: "div",
    },
    tutorFilesById: {
        file: "div",
        name: "button",
        size: "div",
        uploading: "div",
        download: "button",
        downloadIndicator: "div",
        fileError: "div",
        remove: "button",
        removeIndicator: "div",
    },
});
const codeEditor = build({
    loading: "div",
    fileViewLoading: "div",
    accesibilityMenu: "button",
    fileView: "div",
    toolbar: {
        loading: "div",
        expand: "button",
        exportFiles: "button",
        addFile: "button",
        collapse: "button",
        newFileName: "input",
        newFileNameError: "div",
        addNewFile: "button",
    },
    fileById: {
        remove: "button",
        name: "div",
        selectFile: "button",
        editName: "input",
    },
});
const textEditor = build({
    fontColor: {
        selectBase: "button",
        itemById: "button",
        selected: "div",
    },
    fontSize: {
        selectBase: "button",
        itemById: "button",
        selected: "div",
    },
    bold: "button",
    italic: "button",
    underline: "button",
    strike: "button",
    highlight: "button",
    orderedList: "button",
    unorderedList: "button",
    todoList: "button",
    leftAlign: "button",
    centerAlign: "button",
    rightAlign: "button",
    indent: "button",
    unindent: "button",
    undo: "button",
    redo: "button",
    latex: {
        button: "button",
        popup: "div",
        textArea: "input",
        help: "button",
        cancel: "button",
        apply: "button",
    },
    accessibility: "button",
    accessibilityPopup: "div",
    textArea: "input",
    export: "button",
    exportIndicator: "div",
});
const subjects = build({
    categoryById: "button",
    subjectById: "button",
    save: "button",
    topThreeById: {
        select: "input",
        optionById: { option: "button" },
        noResults: "div",
    },
    topThreeError: "div",
});
const tutorProfile = build({
    headline: "input",
    headlineError: "div",
    gender: {
        select: "input",
        optionById: {
            option: "button",
        },
        noResults: "div",
        error: "div",
    },
    about: "input",
    aboutError: "div",
    teaching: "input",
    teachingError: "div",
    workById: {
        title: "input",
        company: "input",
        start: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        end: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        dateError: "div",
        current: "button",
        description: "input",
        remove: "button",
    },
    addWork: "button",
    educationById: {
        college: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        major: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        degree: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        start: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        end: {
            select: "input",
            optionById: {
                option: "button",
            },
            noResults: "div",
            error: "div",
        },
        dateError: "div",
        remove: "button",
    },
    addEducation: "button",
    save: "button",
});
exports.source = build({
    adminDash,
    modals: {
        overlay: "div",
        textEditorAccessibilityModal: {
            close: "button",
        },
        signInModal: {
            facebook: "button",
            google: "button",
            email: "input",
            password: "input",
            recaptcha: "button",
            forgotPassword: "button",
            signIn: "button",
            signUp: "button",
            emailError: "div",
            passwordError: "div",
            recaptchaError: "div",
        },
        signUpModal: {
            facebook: "button",
            google: "button",
            useEmail: "button",
            terms: "button",
            privacy: "button",
            honorCode: "button",
            signIn: "button",
        },
        emailSignUpModal: {
            close: "button",
            facebook: "button",
            google: "button",
            firstName: "input",
            lastName: "input",
            email: "input",
            password: "input",
            recaptcha: "button",
            signUp: "button",
            terms: "button",
            privacy: "button",
            honorCode: "button",
            signIn: "button",
            firstNameError: "div",
            lastNameError: "div",
            emailError: "div",
            passwordError: "div",
            recaptchaError: "div",
        },
        finishModal: {
            firstName: "input",
            lastName: "input",
            email: "input",
            password: "input",
            signIn: "button",
            firstNameError: "div",
            lastNameError: "div",
            emailError: "div",
            passwordError: "div",
        },
        confirmModal: {
            emailById: "div",
            resend: "button",
            indicator: "div",
        },
        changePasswordModal: {
            close: "button",
            oldPassword: "input",
            newPassword: "input",
            update: "button",
            oldPasswordError: "div",
            newPasswordError: "div",
        },
        changeEmailModal: {
            close: "button",
            email: "input",
            update: "button",
            emailError: "div",
        },
        set_passwordModal: {
            close: "button",
            password: "input",
            setPassword: "button",
            passwordError: "div",
        },
        link_sentModal: {
            close: "button",
            openChat: "button",
        },
        resetPasswordModal: {
            close: "button",
            email: "input",
            reset: "button",
            emailError: "div",
        },
        requestLessonFormModal: {
            close: "button",
            subjectById: "div",
            description: "input",
            descError: "div",
            addFiles: "input",
            filesById: {
                name: "div",
                openFile: "button",
                remove: "button",
            },
            submit: "button",
            indicator: "div",
            error: "div",
            reload: "button",
        },
        notifyingTutorsModal: {
            messageById: "div",
            cancel: "button",
            indicator: "button",
            pause: "button",
            minimize: "button",
            checkboxById: "button",
        },
        requestRejectedModal: {
            close: "button",
            subjectById: "div",
            browseTutors: "button",
            tryAgain: "button",
            okay: "button",
            messageTutor: "button",
            tutorById: "div",
            indicator: "div",
        },
        confirmCancelModal: {
            keepSearching: "button",
            cancel: "button",
            indicator: "div",
        },
        requestPenaltyModal: {
            close: "button",
            timer: "div",
            okGotIt: "button",
        },
        waitingForTutorModal: {
            tutorById: "div",
            cancel: "button",
            indicatorMain: "div",
            indicatorCancel: "div",
        },
        connectTutorModal: {
            close: "button",
            tutorById: {
                avatar: "div",
                shortName: "div",
                tagline: "div",
                college: "div",
            },
            subjectSelect: "input",
            optionById: { option: "button" },
            subjectNoResults: "div",
            subjectError: "div",
            sendRequest: "button",
            unsupportedBrowser: "div",
            getChrome: "button",
            getFirefox: "button",
            indicator: "div",
            description: "input",
            indicatorSubmitting: "div",
        },
        claimLessonModal: {
            close: "button",
            progressBar: "div",
            timer: "div",
            studentById: "div",
            subjectById: "div",
            description: "div",
            filesById: {
                name: "div",
                openFile: "button",
            },
            claim: "button",
            indicator: "div",
            error: "div",
            lessonNotAvailable: "button",
        },
        requestModal: {
            studentById: {
                name: "div",
                avatar: "div",
            },
            subjectById: "div",
            reject: "button",
            accept: "button",
            error: "div",
            indicator: "div",
        },
        rejectRequestModal: {
            close: "button",
            studentById: "div",
            sendMessage: "button",
            gotIt: "button",
        },
        voidLessonModal: {
            close: "button",
            reasonById: "button",
            comments: "input",
            commentsError: "div",
            error: "div",
            submitting: "div",
            returnToLesson: "button",
            void: "button",
        },
        endLessonModal: {
            close: "button",
            cancel: "button",
            end: "button",
        },
        pauseLessonModal: {
            resume: "button",
            end: "button",
        },
        awaitingOpponentModal: {
            waitingForTutor: "div",
            waitingForStudent: "div",
            notBilled: "div",
            void: "button",
            end: "button",
        },
        mathQuillModal: {
            close: "button",
            loading: "div",
            sqrt: "button",
            frac: "button",
            sum: "button",
            power: "button",
            greaterThan: "button",
            lessThan: "button",
            notEqual: "button",
            infinity: "button",
            pi: "button",
            input: "input",
            submit: "button",
        },
        desmosModal: {
            root: "div",
            cancel: "button",
            submit: "button",
        },
        shortcutsModal: {
            close: "button",
            okay: "button",
        },
        firstTimeModal: {
            opponentNameById: "div",
            gotIt: "button",
        },
        tutorVoidedModal: {
            close: "button",
            browseTutorsLink: "button",
            COCLink: "button",
            messageUs: "button",
            browseTutors: "button",
            searchAgain: "button",
            okay: "button",
        },
        somethingWentWrongModal: {
            messageUs: "button",
            goToDashboard: "button",
            browseTutors: "button",
            searchAgain: "button",
        },
        freeTrialEndedModal: {
            userById: {
                title: "div",
                message: "div",
            },
            messageStudent: "button",
        },
        reviewLessonModal: {
            avatar: "div",
            favoriteTutor: "button",
            studentName: "div",
            leaveFeedback: "button",
            starsById: "button",
            description: "input",
            descriptionError: "div",
            earnings: "div",
            subject: "div",
            duration: "div",
            starsError: "div",
            submit: "button",
        },
        tutorAppSubmittedModal: {
            close: "button",
            okay: "button",
        },
        writingLabModal: {
            close: "button",
            logo: "div",
            predropoffModal: {
                understand: "button",
            },
            goBack: "button",
            previous: "button",
            stepIndicatorById: "div",
            title: "input",
            titleError: "div",
            description: "input",
            descriptionError: "div",
            nativeEnglish: "button",
            paperStyleById: "button",
            paperStyleOther: "input",
            paperStyleError: "div",
            next: "button",
            fileInput: "input",
            fileBrowse: "button",
            fileError: "div",
            fileById: {
                wrapper: "div",
                remove: "button",
                error: "div",
            },
            characters: "div",
            estimatedTime: "div",
            availableMinutes: "div",
            freeTrialTime: "div",
            freeTrialMinutes: "div",
            timeEstimate: "div",
            enoughTime: "div",
            willBeCharged: "div",
            freeReview: "div",
            honorCode: "button",
            submit: "button",
            returnToHomepage: "button",
        },
        writingLabCancelModal: {
            close: "button",
            reasonById: "button",
            description: "input",
            descriptionError: "div",
            neverMind: "button",
            yesCancel: "button",
        },
        writingLabClaimedModal: {
            close: "button",
            returnToDash: "button",
        },
        writingLabReminderModal: {
            close: "button",
            learnMore: "button",
            honorCode: "button",
            gotIt: "button",
        },
        writingLabSubmitModal: {
            close: "button",
            fileInput: "input",
            fileBrowse: "button",
            fileError: "div",
            fileById: {
                wrapper: "div",
                remove: "button",
                error: "div",
            },
            learnMore: "button",
            comments: "input",
            commentsError: "div",
            checkbox: "button",
            checkboxError: "div",
            honorCode: "button",
            submit: "button",
        },
        writingLabTurnaroundTimeAlertModal: {
            close: "button",
            continue: "button",
            submit: "button",
        },
        writingLabAcceptDeniedModal: {
            close: "button",
            liveLessonMessage: "div",
            writingLabMessage: "div",
            gotIt: "button",
        },
        writingLabExpiredModal: {
            close: "button",
            title: "div",
            expiredHeader: "div",
            expiredMessage: "div",
            cantReviewHeader: "div",
            cantReviewMessage: "div",
            gotIt: "button",
            resubmit: "button",
        },
        writingLabClaimModal: {
            close: "button",
            progress: "div",
            timer: "div",
            notes: "div",
            chars: "div",
            format: "div",
            nativeEnglish: "div",
            quotedTime: "div",
            earnings: "div",
            attachment: "button",
            claim: "button",
        },
        writingLabProgressModal: {
            close: "button",
            notes: "div",
            chars: "div",
            format: "div",
            nativeEnglish: "div",
            quotedTime: "div",
            earnings: "div",
            attachment: "button",
        },
        writingLabReviewPastModal: {
            close: "button",
            title: "div",
            notes: "div",
            download: "button",
            docTitle: "div",
            docDownload: "button",
            rejectedReasonById: "div",
            resubmit: "button",
            starsById: "button",
            description: "input",
            descriptionError: "input",
            leaveFeedback: "button",
            submit: "button",
        },
        chatExportModal: {
            loading: "div",
        },
        scheduleLessonModal: {
            close: "button",
            goBack: "button",
            summaryDate: "div",
            summaryDuration: "div",
            summarySubject: "div",
            submit: "button",
            submitIndicator: "div",
            month: "div",
            previousMonth: "button",
            nextMonth: "button",
            dateById: "button",
            timeSelect: "input",
            timeOptionById: { option: "button" },
            timeNoResults: "div",
            timeLoading: "div",
            subjectSelect: "input",
            subjectOptionById: { option: "button" },
            subjectNoResults: "div",
            subjectsLoading: "div",
            durationById: "button",
            error: "div",
            continue: "button",
        },
        scheduleLessonTutorAcceptedModal: {
            close: "button",
            okGotIt: "button",
            date: "div",
        },
        scheduleLessonTutorRejectedModal: {
            close: "button",
            okGotIt: "button",
            date: "div",
        },
        scheduleLessonTutorCancelledModal: {
            close: "button",
            okGotIt: "button",
            date: "div",
        },
        scheduleLessonStartingSoonModal: {
            goToWaitingRoom: "button",
        },
        scheduleLessonCancelModal: {
            close: "button",
            checkbox: "button",
            fee: "div",
            cancelLesson: "button",
            nevermind: "button",
        },
        accountSuspendedModal: {
            close: "button",
            contactUs: "button",
            okay: "button",
        },
        otpModal: {
            numberInputById: "input",
            error: "div",
            apiError: "div",
            submit: "button",
            useDifferentNumber: "button",
        },
        tutorApplicationRejectedModal: {
            close: "button",
            continue: "button",
        },
        cardModal: {
            close: "button",
            name: "input",
            nameError: "div",
            card: "input",
            cardError: "div",
            submit: "button",
        },
        failedPaymentModal: {
            close: "button",
            name: "input",
            nameError: "div",
            card: "input",
            cardError: "div",
            submit: "button",
            proceed: "button",
            proceedLoading: "div",
            addNewCard: "button",
            selectCard: "button",
            defaultNotice: "div",
            storedCardById: {
                selectCard: "button",
                number: "div",
                declined: "div",
                newDefault: "div",
            },
        },
        checkoutModal: {
            close: "button",
        },
        accountDeactivatedModal: {
            close: "button",
            activate: "button",
        },
        spinnerModal: {
            loading: "div",
        },
        tutorAgreementModal: {
            dataLoading: "div",
            error: "div",
            agreement: "div",
            checkbox: "button",
            checkboxError: "div",
            continue: "button",
            submitting: "div",
        },
        applicationUnderReviewModal: {
            close: "button",
            gotIt: "button",
        },
        inactiveModal: {
            close: "button",
        },
        deactivateAccountModal: {
            close: "button",
            nevermind: "button",
            deactivate: "button",
        },
        incompatibleBrowserModal: {
            close: "button",
            chrome: "button",
            goToStudentMode: "button",
        },
        partnershipModal: {
            close: "button",
            terms: "button",
            privacy: "button",
            helpCenter: "button",
            continue: "button",
        },
        passwordResetSuccessfulModal: {
            close: "button",
            homepage: "button",
        },
        filestackPreviewModal: {
            close: "button",
            loading: "div",
            error: "div",
            doc: "div",
        },
        imagePreviewModal: {
            close: "button",
            img: "button",
        },
        imageModerationModal: {
            close: "button",
        },
        lmsLockModal: {
            close: "button",
            okay: "button",
        },
        lmsLoginExpiredModal: {
            close: "button",
            okay: "button",
        },
        onlyLmsSubjectModal: {
            close: "button",
            signOut: "button",
            continue: "button",
        },
        oauthErrorsModal: {
            close: "button",
            okay: "button",
            no_first_name: "div",
            no_last_name: "div",
            no_email: "div",
            email_exists: "div",
        },
        umbrellaWelcomeModal: {
            close: "button",
            getStarted: "button",
        },
        umbrellaLimitModal: {
            close: "button",
            okay: "button",
            limit: "div",
            contact: "button",
            email: "button",
        },
        umbrellaAgreementModal: {
            close: "button",
            agree: "button",
            cancel: "button",
        },
        umbrellaDisabledModal: {
            email: "button",
            contact: "button",
        },
        softTimeLimitModal: {
            close: "button",
            okay: "button",
        },
        reportUserModal: {
            close: "button",
            closeButton: "button",
            submittedHeader: "div",
            nevermind: "button",
            report: "button",
            error: "div",
            textarea: "input",
        },
        payAsYouGoSurveyModal: {
            close: "button",
            loading: "div",
            checkboxById: "button",
            other: "button",
            error: "div",
            textarea: "input",
            submit: "button",
            submitLoading: "div",
        },
        pdfPageSelectModal: {
            close: "button",
            loading: "div",
            pageById: "button",
        },
        changeAvatarModal: {
            close: "button",
            crop: "button",
            cancel: "button",
            loading: "div",
        },
        plansModal: {
            close: "button",
            nevermind: "button",
            cancel: "button",
            bestValue: "div",
            currentPlan: "div",
            optionById: {
                select: "button",
                hours: "div",
                cost: "div",
                additionalCost: "div",
            },
            payAsYouGoOption: "button",
            payAsYouGoRate: "div",
            periodNotice: "div",
            renewalDate: "div",
            changePlan: "button",
            startFreeTrial: "button",
            schoolAdmin: "button",
        },
        editChatImageMessageModal: {
            close: "button",
            name: "input",
            description: "input",
            cancel: "button",
            save: "button",
        },
        matchPalModal: {
            close: "button",
            response: "input",
            send: "button",
            messageById: "div",
            confirmGoals: "button",
            rejectGoals: "button",
            piiMessage: "div",
            confirmNoPII: "button",
            redoInput: "button",
            continueRequest: "button",
        },
    },
    authPages: {
        logo: "button",
        privacy: "button",
        terms: "button",
        codeOfConduct: "button",
        signIn: {
            google: "button",
            email: "input",
            password: "input",
            recaptcha: "button",
            forgotPassword: "button",
            signIn: "button",
            applyToTutor: "button",
            joinOrg: "button",
            emailError: "div",
            passwordError: "div",
            recaptchaError: "div",
        },
        joinOrg: {
            firstName: "input",
            lastName: "input",
            email: "input",
            firstNameError: "div",
            lastNameError: "div",
            emailError: "div",
            submit: "button",
            alreadySetUp: "div",
            success: "div",
        },
        applyToTutor: {
            google: "button",
            firstName: "input",
            lastName: "input",
            email: "input",
            password: "input",
            recaptcha: "button",
            firstNameError: "div",
            lastNameError: "div",
            emailError: "div",
            passwordError: "div",
            recaptchaError: "div",
            privacy: "button",
            terms: "button",
            codeOfConduct: "button",
            createAccount: "button",
            signIn: "button",
        },
        resetPassword: {
            email: "input",
            emailError: "div",
            sendResetLink: "button",
            successMessage: "div",
            support: "button",
            passwordResetSuccessMessage: "div",
            backToSignIn: "button",
            expiredMessage: "div",
            backToReset: "button",
            password: "input",
            passwordError: "div",
            setNewPassword: "button",
        },
        authError: {
            lmsLock: "div",
            suspended: "div",
            deactivated: "div",
            signupForbidden: "div",
            partnerSignup: "div",
            button: "button",
            support: "button",
        },
    },
    toast: {
        success: "div",
        error: "div",
    },
    header: {
        logo: "button",
        browseTutors: "button",
        help: "button",
        userTools: {
            avatar: "button",
            username: "button",
            dropdown: "div",
            openMenu: "button",
        },
        notifications: {
            tutorResources: {
                button: "button",
                amount: "div",
                dateById: "div",
                itemById: "button",
            },
            chat: {
                button: "button",
                amount: "div",
                markAllRead: "button",
                loading: "div",
                contactById: {
                    item: "button",
                    avatar: "div",
                    name: "div",
                    online: "div",
                    date: "div",
                    text: "div",
                    fileName: "div",
                },
            },
            other: {
                button: "button",
                amount: "div",
                loading: "div",
                itemById: {
                    item: "button",
                    status: "div",
                    title: "div",
                    date: "div",
                },
                empty: "div",
            },
        },
    },
    userMenu: {
        dashboard: "button",
        myAccount: "button",
        billing: "button",
        usage: "button",
        pastLessons: "button",
        helpCenter: "button",
        demoLessonSpace: "button",
        becomeATutor: "button",
        installTutormeDesktop: "button",
        signOut: "button",
        switch: "button",
        switchIndicator: "div",
        switchTooltip: "div",
        editProfile: "button",
        privacyPolicy: "button",
        terms: "button",
    },
    footer: {
        logo: "button",
        terms: "button",
        privacy: "button",
        company: "button",
        help: "button",
        honorCode: "button",
        demoLessonSpace: "button",
        browseTutors: "button",
        californiaNotice: "button",
        privacyPolicy: "button",
    },
    sessionRequest: {
        stepIndicatorById: "div",
        gradeById: "button",
        categoryById: "button",
        next: "button",
        previous: "button",
        nextArrow: "button",
        previousArrow: "button",
        close: "button",
        logo: "div",
        subjectById: "button",
        uploadFile: {
            input: "input",
            error: "div",
            fileById: {
                name: "div",
                remove: "button",
                error: "div",
            },
        },
        description: "input",
        descriptionError: "div",
        requestTutor: "button",
        codeOfConduct: "button",
        communicationById: "button",
        confidenceById: "button",
        refineSearch: "button",
        matchPalCTA: "button",
        sessionGoals: "div",
    },
    checkout: {
        header: {
            trialEligible: "div",
            default: "div",
        },
        freeLessonOver: "div",
        subtitle: "div",
        info: {
            trialEligible: "div",
            additionalTime: "div",
            plan: "div",
            rate: "div",
            todaysCharge: "div",
            studentCounter: "div",
        },
        name: "input",
        nameError: "div",
        card: "input",
        cardError: "div",
        submit: "button",
        trialEligible: "div",
        expandPromoCode: "button",
        promoCodeInput: "input",
        closePromoCode: "button",
        submitPromoCode: "button",
        promoCodeLoading: "div",
        promoCodeError: "div",
        clearPromoCode: "button",
        promoCodeApplied: "div",
    },
    homepage: {
        writingLab: "button",
        demoLessonSpace: "button",
        requestATutor: "button",
        browseTutorsList: "button",
        history: "button",
        browseAllTutors: "button",
        subjectById: "button",
    },
    lessonSpace: {
        header: {
            logo: "div",
            title: "div",
            timerToggle: "button",
            timerDisplay: "div",
            end: "button",
            void: "button",
            pause: "button",
            help: "button",
            avatarById: "div",
            usernameById: "div",
            mode: "div",
            recordingIndicator: "button",
            timerTooltipGotIt: "button",
        },
        isMobileMessage: "div",
        opponentTooltip: "div",
        opponentIcon: "div",
        sessionPlanButton: "button",
        whiteboardButton: "button",
        calculatorButton: "button",
        textEditorButton: "button",
        codeEditorButton: "button",
        google: "button",
        fileUpload: "button",
        screenShareTooltip: "div",
        screenShareSwitch: "button",
        loading: "div",
        loadingError: "div",
        fullScreen: "button",
        fullScreenTooltip: "div",
        video,
        whiteboard,
        googleDocs,
        documents,
        calculator: "div",
        codeEditor,
        textEditor,
        chat,
        sessionDetails: {
            toggle: "button",
            grade: "div",
            confidence: "div",
            communication: "div",
            sessionPlanLink: "button",
            pearAssessmentDomains: "div",
            ggtDescription: "div",
        },
        sessionPlan: {
            subject: "div",
            grade: "div",
            confidence: "div",
            communication: "div",
            tutorGoalsById: "button",
            raiseGoalsById: "button",
            raiseLink: "button",
            teacherNotes: "div",
            ggtAssigned: "div",
            pearAssessmentAssigned: "div",
        },
        gamePanel: {
            minimize: "button",
            draw: "button",
            wordSearch: "button",
            math: "button",
            whiteboardtools: "button",
            drawingDone: "button",
            newDrawing: "button",
            wordSearchDone: "button",
            newWordSearch: "button",
            wordSearchCheckboxById: "button",
            mathLevelById: "button",
            mathInput: "input",
            mathStart: "button",
            mathSkip: "button",
            mathSubmit: "button",
            mathPlayAgain: "button",
            backToGames: "button",
        },
    },
    demoLessonSpace: {
        header: {
            logo: "div",
            title: "div",
            timerToggle: "button",
            timerDisplay: "div",
            support: "button",
            exit: "button",
        },
        whiteboardButton: "button",
        calculatorButton: "button",
        textEditorButton: "button",
        codeEditorButton: "button",
        google: "button",
        fileUpload: "button",
        screenShareTooltip: "div",
        screenShareSwitch: "button",
        loading: "div",
        loadingError: "div",
        fullScreen: "button",
        fullScreenTooltip: "div",
        video,
        whiteboard,
        googleDocs,
        documents,
        calculator: "div",
        codeEditor,
        textEditor,
        chat,
    },
    pastLessonSpace: {
        header: {
            logo: "div",
            title: "div",
            exit: "button",
        },
        whiteboardButton: "button",
        calculatorButton: "button",
        textEditorButton: "button",
        codeEditorButton: "button",
        google: "button",
        fileUpload: "button",
        video,
        whiteboard,
        googleDocs,
        documents,
        calculator: "div",
        codeEditor,
        textEditor,
        chat,
    },
    account: {
        account: "button",
        qrCode: "button",
        notifications: "button",
        billing: "button",
        usage: "button",
        tutorAccount: "button",
        tutorSubjects: "button",
        profile: {
            avatar: {
                dropTarget: "div",
                changeButton: "button",
                changeText: "div",
                input: "input",
                error: "div",
            },
            firstName: "input",
            firstNameError: "div",
            lastName: "input",
            lastNameError: "div",
            email: "input",
            changeEmail: "button",
            changePassword: "button",
            logoutAll: "button",
            deactivate: "button",
            life: {
                select: "input",
                optionById: { option: "button" },
                noResults: "div",
            },
            phone: "input",
            phoneError: "div",
            countryCode: {
                select: "input",
                optionById: {
                    option: "button",
                },
                noResults: "div",
            },
            sendOTP: "button",
            otpError: "div",
            submit: "button",
            submitIndicator: "div",
        },
        notificationsOptions: {
            sendDesktop: "button",
            validatingSettings: "div",
            notInSync: "div",
            resync: "button",
            inSync: "div",
            firefox: "button",
            chrome: "button",
            sendEmails: "button",
            popup: "button",
            sendTexts: "button",
            missedMessages: "button",
        },
        usageDetails: {
            limit: "div",
            remaining: "div",
            progressBar: "div",
            resets: "div",
            extraTime: "div",
            email: "button",
            insitution: "div",
        },
        qr: {
            loading: "div",
            code: "div",
        },
        billingInfo: {
            currentPlan: "div",
            bonusTime: "div",
            renewalDate: "div",
            nextPlanName: "div",
            changePlan: "button",
            progressBar: "div",
            payAsYouGo: "div",
            purchaseMembership: "button",
            processing: "div",
            showMore: "button",
            loadingTransactions: "div",
            addNewCard: "button",
            addingCard: "div",
            callBankMessage: "div",
            retryCharge: "button",
            failedCharge: "div",
            failedMessage: "div",
            cardById: {
                type: "div",
                number: "div",
                makeDefault: "button",
                remove: "button",
                isDefault: "div",
            },
            transactionById: {
                date: "div",
                plan: "div",
                amount: "div",
                time: "div",
                status: "div",
                card: "div",
                description: "div",
            },
        },
        tutorProfile,
        subjects,
        languageById: "button",
        pastLessons: {
            tutoring: {
                tutorById: {
                    avatar: "div",
                    name: "button",
                    favorite: "button",
                    link: "button",
                    suspended: "div",
                },
                subjectById: "div",
                startTimeById: "div",
                durationById: "div",
                viewLessonById: "button",
                link: "button",
            },
            writing: {
                link: "button",
                statusById: "div",
                titleById: "div",
                dateById: "div",
                reviewById: "button",
            },
            scheduledLessons: {
                link: "button",
                tutorById: {
                    avatar: "div",
                    name: "button",
                    favorite: "button",
                    link: "button",
                    suspended: "div",
                },
                subjectById: "div",
                startTimeById: "div",
                durationById: "div",
                cancel: "button",
                remove: "button",
            },
        },
    },
    tutors: {
        header: {
            browseTutors: "button",
            categoryLink: "button",
            subjectLink: "button",
            title: "div",
        },
        notFound: "div",
        notFoundShowAllTutors: "button",
        filter: {
            allSubjects: "button",
            categoryById: "button",
            subjectById: "button",
            onlineNow: "button",
            familiarity: "button",
            languageById: "button",
            showMore: "button",
            suggest: "input",
            optionById: { option: "button" },
            noResults: "div",
        },
        removeFilter: {
            onlineNow: "button",
            familiarity: "button",
            languageById: "button",
            clearAll: "button",
        },
        searchPath: "div",
        subjectLinkById: "button",
        categoryLinkById: "button",
        showMore: "button",
        noResults: "div",
        noResultsClearFilters: "button",
        noResultsShowAllTutors: "button",
        backToTop: "button",
        tutorById: {
            card: "button",
            avatar: "div",
            name: "div",
            subject: "div",
            tagline: "div",
            viewProfile: "div",
            languages: "div",
            subjects: "div",
            languageById: "div",
            subjectById: "div",
        },
    },
    tutorProfile: {
        tutorById: tutorInfo,
        backToSearch: "button",
        favorite: "button",
        favoriteTooltip: "div",
        satisfactionGuarantee: "div",
        bio: "button",
        questions: "button",
        contactTutorName: "div",
        contact: "button",
        contactTooltip: "div",
        requestLesson: "button",
        requestLessonTooltip: "div",
        faqById: {
            question: "button",
            answer: "div",
        },
        loadingPage: "div",
        loadingPageError: "div",
        subjectAreaById: "div",
        languageById: "div",
    },
    roster: {
        loading: "div",
        toggle: "button",
        schoolTutors: "div",
        favorites: "div",
        subjectById: "button",
        contact: "button",
        recent: {
            contactById: {
                avatar: "div",
                name: "div",
                college: "div",
                openChat: "button",
            },
        },
        schoolContacts: {
            contactById: {
                avatar: "div",
                name: "div",
                college: "div",
                openChat: "button",
            },
        },
        favorite: {
            contactById: {
                avatar: "div",
                name: "div",
                college: "div",
                openChat: "button",
            },
        },
        tutorById: {
            profile: "button",
            name: "button",
            avatar: "div",
            favorite: "button",
            tagline: "div",
            getHelp: "button",
        },
        title: "div",
    },
    chatById: chat,
    tutorApp: {
        help: "button",
        buttonTop: {
            applyNow: "button",
            continue: "button",
            switchToTutorMode: "button",
            tutorDash: "button",
        },
        buttonBottom: {
            applyNow: "button",
            continue: "button",
            switchToTutorMode: "button",
            tutorDash: "button",
        },
        carousel: {
            itemById: "div",
            leftArrow: "button",
            rightArrow: "button",
            dotById: "button",
        },
        header: {
            account: "button",
            profile: "button",
            subjects: "button",
            questions: "button",
            dbsCheck: "button",
        },
        profile: {
            avatar: {
                dropTarget: "div",
                changeButton: "button",
                changeText: "div",
                input: "input",
                error: "div",
                instructions: "div",
            },
            firstName: "input",
            firstNameError: "div",
            lastName: "input",
            lastNameError: "div",
            email: "input",
            life: {
                select: "input",
                optionById: {
                    option: "button",
                },
                noResults: "div",
            },
            phone: "input",
            phoneError: "div",
            countryCode: {
                select: "input",
                optionById: {
                    option: "button",
                },
                noResults: "div",
            },
            sendOTP: "button",
            otpError: "div",
            submit: "button",
            submitIndicator: "div",
        },
        tutorProfile,
        subjects,
        interview: {
            loading: "div",
            subjectById: "div",
            latex: "button",
            questionById: "input",
            answerById: "input",
            previous: "button",
            next: "button",
            submit: "button",
        },
    },
    tutorDashboard: {
        header: {
            viewProfile: "button",
            avatar: "div",
            firstName: "div",
            editProfile: "button",
            paypal: "button",
            email: "div",
            writingLabsInProgress: "button",
            availableTutoring: "button",
            earnings: "button",
            pastTutoring: "button",
            checkr: "button",
            heatmap: "button",
            resources: "button",
            logo: "button",
            demoLessonSpace: "button",
            helpCenter: "button",
            userTools: {
                avatar: "button",
                username: "button",
                dropdown: "div",
                openMenu: "button",
            },
            notifications: {
                tutorResources: {
                    button: "button",
                    amount: "div",
                    dateById: "div",
                    itemById: "button",
                },
                chat: {
                    button: "button",
                    amount: "div",
                    markAllRead: "button",
                    loading: "div",
                    contactById: {
                        item: "button",
                        avatar: "div",
                        name: "div",
                        online: "div",
                        date: "div",
                        text: "div",
                        fileName: "div",
                    },
                },
            },
        },
        dashboard: {
            subjects: "button",
            notifications: "button",
            availableLessonById: {
                subject: "div",
                username: "div",
                avatar: "div",
                expires: "div",
                claim: "button",
            },
            writingLabById: {
                claim: "button",
                writingLabRequest: "div",
            },
        },
        earnings: {
            loading: "div",
            loadingError: "div",
            noEarnings: "div",
            currentWeekAmount: "div",
            info: "div",
            cumulativeAmount: "div",
        },
        inProgressById: {
            download: "button",
            cancel: "button",
            submit: "button",
            expired: "div",
            timer: "div",
            timerLoading: "div",
        },
        pastLessons: {
            pastLessons: "button",
            pastWriting: "button",
            noHistory: "div",
            subjects: "button",
            notifications: "button",
            studentById: {
                avatar: "div",
                name: "button",
                favorite: "button",
                suspended: "div",
            },
            subjectById: "div",
            startTimeById: "div",
            earningsById: "div",
            noRatingById: "div",
            starsById: "button",
            viewLessonById: "button",
            findLessons: "button",
        },
        pastWriting: {
            subjects: "button",
            notifications: "button",
            titleById: "div",
            dateById: "div",
            starById: "button",
            earningsById: "div",
            reviewById: "button",
            expiredById: "div",
            cancelledById: "div",
            findWriting: "button",
        },
        checkr: {
            privacyPolicy: "button",
            protectData: "button",
            collectData: "button",
            shareData: "button",
            finish: "button",
            checkStatus: "button",
            completed: "div",
            info: "div",
            emailSupport: "button",
            start: "button",
            select: "input",
            optionById: { option: "button" },
            noResults: "div",
        },
        heatmap: {
            loading: "div",
            loadingError: "div",
            subjects: "button",
            demandById: "div",
            dayById: "div",
        },
        resources: {
            news: {
                loading: "div",
                noNews: "div",
                itemById: {
                    item: "div",
                    header: "div",
                    date: "div",
                    fullItem: "div",
                    preview: "div",
                    toggleReadMore: "button",
                },
            },
            handbook: "button",
            handbookWritingLab: "button",
            handbookLibraries: "button",
            notifications: "button",
            demoLessonSpace: "button",
            tutorProfile: "button",
            subjects: "button",
            writingLabTips: "button",
            writingLabComments: "button",
            concerns: "button",
            templatedWritingFeedback: "button",
            helpCenter: "button",
            contactUs: "button",
        },
    },
    studentAcctCreation: {
        firstName: "input",
        lastName: "input",
        email: "input",
        submit: "button",
    },
});
function build(struct) {
    return struct;
}
